import { useFlags } from 'providers/launchdarklyHooks'

import { FeatureFlagKey, FeatureFlags } from 'featureFlags/types'

const useFeatureFlags = (): FeatureFlags => {
  const flags = useFlags()

  const featureFlags = {
    abbyaidOnboardingAccountInformation: flags[FeatureFlagKey.AbbyAidOnboardingAccountInformation],
    debugLogs: flags[FeatureFlagKey.DebugLogs],
    flows: flags[FeatureFlagKey.Flows],
    enableEditingOrders: flags[FeatureFlagKey.EnableEditingOrders],
    isAutoFaxEnabled: flags[FeatureFlagKey.IsAutoFaxEnabled],
    enableAdminOnboardingInternalPage: flags[FeatureFlagKey.EnableAdminOnboardingInternalPage],
    followUpAssessments: flags[FeatureFlagKey.FollowUpAssessments],
    tasksV2: flags[FeatureFlagKey.TasksV2],
    fuaRelease2: flags[FeatureFlagKey.FuaRelease2],

    patSunset: flags[FeatureFlagKey.PatSunset],
    assign485ReviewOwner: flags[FeatureFlagKey.Assign485ReviewOwner],
    profileDeduplication: flags[FeatureFlagKey.ProfileDeduplication],
    abbyIndex: flags[FeatureFlagKey.AbbyIndex],
    assessmentRearchitecture: flags[FeatureFlagKey.AssessmentRearchitecture],
    aiAutofill: flags[FeatureFlagKey.AiAutofill],
    visitQaSunsetEnabled: flags[FeatureFlagKey.VisitQaSunsetEnabled],
    authorizationUpdates: flags[FeatureFlagKey.AuthorizationUpdates],
    editGhostAuthStatus: flags[FeatureFlagKey.EditGhostAuthStatus],
    clinicalExports: flags[FeatureFlagKey.ClinicalExports],
    visitScheduleRemediation: flags[FeatureFlagKey.VisitScheduleRemediation],
    sessionExpiredModal: flags[FeatureFlagKey.SessionExpiredModal],
    documentRequests: flags[FeatureFlagKey.DocumentRequests],
    allowCaseManagerFilter: flags[FeatureFlagKey.PatientsCaseManagerFilter],
    procedureCodeRemediation: flags[FeatureFlagKey.ProcedureCodeRemediation],
    visitChartedTimeRemediation: flags[FeatureFlagKey.VisitChartedTimeRemediation],
    serviceplanQaOptional: flags[FeatureFlagKey.ServiceplanQaOptional],
    patientNameQueriesLowImpact: flags[FeatureFlagKey.PatientNameQueriesLowImpact],
    patAssessmentRearchitecture: flags[FeatureFlagKey.PatAssessmentRearchitecture],
    patientDataQueries: flags[FeatureFlagKey.PatientDataQueries],
    patientQueriesApiLowImpact: flags[FeatureFlagKey.PatientQueriesApiLowImpact],
    patientChartEvvExempt: flags[FeatureFlagKey.PatientChartEvvExempt],
    docCollection: flags[FeatureFlagKey.DocCollection],
    onboardingDashboard: flags[FeatureFlagKey.OnboardingDashboard],
    patientChartCopilotV1: flags[FeatureFlagKey.PatientChartCopilotV1],
    payorAiBetaFeatures: flags[FeatureFlagKey.PayorAiBetaFeatures],
    visitAuthLinkage: flags[FeatureFlagKey.VisitAuthLinkage],
    externalValidation: flags[FeatureFlagKey.ExternalValidation],
    physicianListRestApi: flags[FeatureFlagKey.PhysicianListRestApi],
    dischargeResourceGenerationCelery: flags[FeatureFlagKey.DischargeResourceGenerationCelery],
    careDeliveryTransfer: flags[FeatureFlagKey.CareDeliveryTransfer],
    trackBuilder: flags[FeatureFlagKey.TrackBuilder],
    trackBuilderBulkApply: flags[FeatureFlagKey.TrackBuilderBulkApply],
    pandadocTemplateConfig: flags[FeatureFlagKey.PandaDocTemplateConfig],
    useTemplateDrivenGates: flags[FeatureFlagKey.UseTemplateDrivenGates],
    allowCreationResourcesForAbbyHub: flags[FeatureFlagKey.AllowCreationResourcesForAbbyHub],
    adminFoundationalData: flags[FeatureFlagKey.AdminFoundationalData],
    supportMultipleAssignees: flags[FeatureFlagKey.SupportMultipleAssignees],
    documentVersioning: flags[FeatureFlagKey.DocumentVersioning],
    trackBuilderTriggers: flags[FeatureFlagKey.TrackBuilderTriggers],
    adminProcesses: flags[FeatureFlagKey.AdminProcesses],
    documentRequestReRequest: flags[FeatureFlagKey.DocumentRequestReRequest],
    pdfDragDrop: flags[FeatureFlagKey.PdfDragDrop],
    pdfEditAndTransfer: flags[FeatureFlagKey.PdfEditAndTransfer],
    docCollectionSlackNotif: flags[FeatureFlagKey.DocCollectionSlackNotif],
    adultPopulation: flags[FeatureFlagKey.AdultPopulation],
    workQueueOwner: flags[FeatureFlagKey.WorkQueueOwner],
    workQueueStatus: flags[FeatureFlagKey.WorkQueueStatus],
    workQueueActivity: flags[FeatureFlagKey.WorkQueueActivity],
    workQueueFlags: flags[FeatureFlagKey.WorkQueueFlags],
    workQueueFlagsFilter: flags[FeatureFlagKey.WorkQueueFlagsFilter],
    workQueueFollowup: flags[FeatureFlagKey.WorkQueueFollowup],
    faxAgentMultiLabel: flags[FeatureFlagKey.FaxAgentMultiLabel],
    parReadiness: flags[FeatureFlagKey.ParReadiness],
    medplumPasswordLoginFeatureRelease: flags[FeatureFlagKey.MedplumPasswordLoginFeatureRelease],
    manualReminders: flags[FeatureFlagKey.ManualReminders],
    existingMedplumUserSorLink: flags[FeatureFlagKey.ExistingMedplumUserSorLink],
    autoResourceGeneration: flags[FeatureFlagKey.AutoResourceGeneration],
    supportExistingCg: flags[FeatureFlagKey.SupportExistingCg],
    removeDocsMedplumFe: flags[FeatureFlagKey.RemoveDocsMedplumFe]
  }

  return featureFlags
}

export default useFeatureFlags
